export default __webpack_public_path__ + "static/appBadgeRegulr-8a96bcb79bec942d8760e28b380f78d8.png";